import dayjs from 'dayjs';
import { monthArray } from '../monthsArray';

/**
 * Calculates monthly data from invoices grouped by year keys (N-1, N, etc.)
 * and sets items data for chart display.
 * This eliminates code duplication between different chart data functions.
 * @function
 * @param {Object} params - Parameters for calculateMonthlyData function.
 * @param {Object} params.dataByKey - Object with year keys (e.g., 'N-1', 'N') as keys and arrays of invoices as values.
 * @param {Function} params.setItems - State setting function for items data.
 * @param {Function} params.t - Translation function for internationalization.
 * @returns {void}
 */
export const calculateMonthlyData = ({ dataByKey, setItems, t }) => {
  const calculatedData = {};

  // Iterate over dataByKey and calculate monthly totals
  Object.entries(dataByKey).forEach(([key, invoices]) => {
    invoices?.forEach((invoice) => {
      // Calculate month key using dayjs.
      const monthKey = dayjs(invoice.payment_date).format('MMMM');

      // Initialize calculatedData object for the key.
      calculatedData[key] = calculatedData[key] || {};

      // Update calculated data for the month and key.
      calculatedData[key][monthKey] =
        (calculatedData[key]?.[monthKey] || 0) + (invoice.total_ttc || 0);
    });
  });

  // Map over monthsArray and set items data.
  monthArray(t).forEach((month) =>
    setItems((prev) => [
      ...prev,
      {
        month,
        salesNMinus1: calculatedData['N-1']?.[month.toLowerCase()] || 0,
        salesN: calculatedData.N?.[month.toLowerCase()] || 0
      }
    ])
  );
};
